"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useURLSearchParams = void 0;
const react_router_dom_1 = require("react-router-dom");
const useURLSearchParams = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const urlSearchParams = new URLSearchParams(history.location.search);
    const getURLParamValue = (paramKey) => urlSearchParams.getAll(paramKey);
    const updateURLParamValue = (paramKey, paramValue) => {
        const existingTypes = urlSearchParams.getAll(paramKey);
        if (existingTypes.length) {
            urlSearchParams.delete(paramKey);
        }
        if (paramValue) {
            if (typeof paramValue === 'string') {
                urlSearchParams.append(paramKey, paramValue);
            }
            else {
                paramValue.forEach((value) => {
                    urlSearchParams.append(paramKey, value);
                });
            }
        }
        const updatedURLString = urlSearchParams.toString();
        history.push(`${history.location.pathname}?${updatedURLString}`);
        return updatedURLString;
    };
    return { getURLParamValue, updateURLParamValue };
};
exports.useURLSearchParams = useURLSearchParams;
//# sourceMappingURL=useURLSearchParams.js.map